import * as i0 from '@angular/core';
import { EventEmitter, inject, ElementRef, ViewContainerRef, ApplicationRef, Injector, Renderer2, Component, ChangeDetectionStrategy, Input, HostBinding, Output } from '@angular/core';
import { NG_DOC_PAGE_PROCESSOR, NG_DOC_PAGE_CUSTOM_PROCESSOR } from '@ng-doc/app/tokens';
import { asArray } from '@ng-doc/core/helpers/as-array';
import { objectKeys } from '@ng-doc/core/helpers/object-keys';

/**
 * Base processor class to create a processor directive that will be used to replace
 * html nodes with an Angular component.
 */
const _c0 = ["ngDocPageProcessor", ""];
const _c1 = ["*"];
let NgDocPageProcessorComponent = /*#__PURE__*/(() => {
  class NgDocPageProcessorComponent {
    constructor() {
      this.html = '';
      this.afterRender = new EventEmitter();
      this.processors = inject(NG_DOC_PAGE_PROCESSOR, {
        optional: true
      }) ?? [];
      this.customProcessors = inject(NG_DOC_PAGE_CUSTOM_PROCESSOR, {
        optional: true
      }) ?? [];
      this.elementRef = inject(ElementRef);
      this.viewContainerRef = inject(ViewContainerRef);
      this.applicationRef = inject(ApplicationRef);
      this.injector = inject(Injector);
      this.renderer = inject(Renderer2);
    }
    ngOnChanges({
      html
    }) {
      if (html) {
        Promise.resolve().then(() => {
          asArray(this.processors, this.customProcessors).forEach(this.process.bind(this));
          this.applicationRef.tick();
          this.afterRender.emit();
        });
      }
    }
    process(processor) {
      Array.from(this.elementRef.nativeElement.querySelectorAll(processor.selector)).forEach(elementNode => {
        // check if element node has a parent node because it can be removed by another processor
        if (elementNode.parentNode) {
          const replaceElement = (processor.nodeToReplace && processor.nodeToReplace(elementNode, this.injector)) ?? elementNode;
          const options = processor.extractOptions(elementNode, this.elementRef.nativeElement);
          // create component
          const componentRef = this.viewContainerRef.createComponent(processor.component, {
            projectableNodes: options.content,
            injector: this.injector
          });
          // set component options
          if (options.inputs) {
            objectKeys(options.inputs).forEach(key => options.inputs && componentRef.setInput(key, options.inputs[key]));
          }
          // replace element node with component node
          replaceElement.parentNode?.replaceChild(componentRef.location.nativeElement, replaceElement);
          componentRef.changeDetectorRef.markForCheck();
        }
      });
    }
    static {
      this.ɵfac = function NgDocPageProcessorComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || NgDocPageProcessorComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: NgDocPageProcessorComponent,
        selectors: [["", "ngDocPageProcessor", ""]],
        hostVars: 1,
        hostBindings: function NgDocPageProcessorComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵhostProperty("innerHTML", ctx.html, i0.ɵɵsanitizeHtml);
          }
        },
        inputs: {
          html: [0, "ngDocPageProcessor", "html"]
        },
        outputs: {
          afterRender: "afterRender"
        },
        standalone: true,
        features: [i0.ɵɵNgOnChangesFeature, i0.ɵɵStandaloneFeature],
        attrs: _c0,
        ngContentSelectors: _c1,
        decls: 1,
        vars: 0,
        template: function NgDocPageProcessorComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
          }
        },
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return NgDocPageProcessorComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { NgDocPageProcessorComponent };
